import gql from 'graphql-tag'
import { makesMutations } from 'data/graphql'

const providesIntegrationActivitySettingsRemove = makesMutations({
  query: gql`
    mutation remove($integrationId: ID!, $channelId: ID!) {
      integrationActivitySettingsRemove(
        input: { channelId: $channelId, integrationId: $integrationId }
      ) {
        success
      }
    }
  `,
  mutationPropName: 'integrationActivitySettingsRemove',
})

export default providesIntegrationActivitySettingsRemove
